module.exports = __webpack_public_path__ + "img/Weapon_264.318dfc75.png";